/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';
import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { queryStateParser, queryParam, backwardsCompatabilityFactory, QueryStateSchema } from './queryStateParser';

const QS_KEY = 'paneDocumentRequestUserId';
const QS_TYPE: QueryStateSchema['type'] = 'documentRequestUser';

export const useOpenDocumentRequestUserPane = (): ((args: { documentRequestUserId: string }) => void) => {
  const [documentRequestUserIdDeprecated, setDocumentRequestUserId] = useQueryState(QS_KEY);
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (documentRequestUserIdDeprecated) {
      setDocumentRequestUserId(null);
      setState(backwardsCompatabilityFactory({ id: documentRequestUserIdDeprecated, type: QS_TYPE }));
    }
  }, [documentRequestUserIdDeprecated]);

  return ({ documentRequestUserId }) => {
    setState(prevState => [...(prevState || []), {
      id: documentRequestUserId,
      key: nanoid(),
      type: QS_TYPE,
    }]);
  };
};
